<mat-expansion-panel [(expanded)]="expanded" [disabled]="disabled()" [hideToggle]="false">
  <mat-expansion-panel-header>
    <mat-panel-title>{{ heading() }}</mat-panel-title>
    @if (description()) {
      <mat-panel-description>{{ description() }}</mat-panel-description>
    }
  </mat-expansion-panel-header>

  <ng-content />
</mat-expansion-panel>
